import React from "react";
import { Box, Editable, EditableInput, EditablePreview, useStyleConfig, } from "@chakra-ui/react";
import { EditableControls } from "./editable-controls";
export function EditableHeading({ isDisabled = false, size = "md", value, width = "lg", onCancel, onChange, onSubmit, ...props }) {
    const headingStyles = useStyleConfig("Heading", {
        size: `heading-${size}`,
        variant: "heading",
    });
    return (React.createElement(Box, { width: width, ...props },
        React.createElement(Editable, { isPreviewFocusable: false, isDisabled: isDisabled, value: value, onCancel: onCancel, onChange: onChange, onSubmit: onSubmit, ...headingStyles },
            React.createElement(Box, { display: "flex", alignItems: "center", gap: 2 },
                React.createElement(EditablePreview, { as: "h2" }),
                React.createElement(EditableInput, { _focusVisible: {
                        boxShadow: "outline",
                    } }),
                React.createElement(EditableControls, null)))));
}
